<div class="container">
  <p>Aqui você pode visualizar suas solicitações de mudança de horário de atendimento:</p>

  <mat-card *ngFor="let request of allRequests" [ngClass]="request?.status">
    <div>
      <strong>{{ transformRequestText(request?.requestType) }}</strong><br />
      {{ request?.specialtyDisplay || getSpecialtyDisplay(request) }}
    </div>
    <div class="status-label">{{ transformStatusText(request?.status) }}</div>
    <div>
      <button mat-flat-button color="primary" (click)="openHoursChangesRequestDetails(request)">Ver detalhes</button>
    </div>
  </mat-card>
</div>
